import EventDispatcher from "../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AbstractDebugView from "../../../../../shared/src/ranj/debug/core/view/AbstractDebugView";
import GameConfig from "../../../equalture/workingmemory/model/GameConfig";
import GameModel from "../../../equalture/workingmemory/model/GameModel";

export default class DebugOutputController extends AbstractDebugView {

    /**
     * 
     * @param {EventDispatcher} dispatcher
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, gameModel, assetLibrary, gameConfig) {
        const keycode = assetLibrary.getAsset("debugtools_config").keyBindings.debugOutput.charCodeAt(0);
        super(keycode, "ranj/debug/modules/debugoutput/DebugOutputGUI.html", "Debug Output", "width=600,height=600");

        this._dispatcher = dispatcher;
        this._gameModel = gameModel;
        this._gameConfig = gameConfig;

        this.handlePuzzle = this.handlePuzzle.bind(this)
        this._gameModel.addEventListener(GameModel.PUZZLE, this.handlePuzzle);
        this._output = this.generatePuzzlesOutput();
    }

    destroy() {
        super.destroy();
        this._gameModel.removeEventListener(GameModel.PUZZLE, this.handlePuzzle);
    }

    onLoad() {
        super.onLoad();
        this._gui.document.getElementById("output").innerHTML = this._output;
        this._gui.document.getElementById("copy").addEventListener("click", this._copy.bind(this));
        this._gui.document.getElementById("showHideSpots").addEventListener("click", this._showHideSpotsInfos.bind(this));
    }

    _copy() {
        this._gui.navigator.clipboard.writeText(this._output).then(() => {
            this.setStatus("Output copied.");
        }, (err) => {
            this.setStatus("Failed to copy!");
        });

    }

    _showHideSpotsInfos() {
        this._dispatcher.dispatch(GameModel.SHOW_SOLUTION_INFO);
    }

    setStatus(str, duration = 2000) {
        this._gui.document.getElementById("status").innerHTML = str;
        if (duration) {
            setTimeout(() => {
                this._gui.document.getElementById("status").innerHTML = "";
            }, duration);
        }
    }

    handlePuzzle(puzzleModel) {
        // Use this to highlight current puzzel in output??
    }

    generatePuzzlesOutput() {
        const puzzlesOriginal = this._gameConfig.getValue("puzzles");
        const practicePuzzlesOriginal = this._gameConfig.getValue("practicePuzzles");
        const puzzlesRandom = this._gameConfig.puzzles;
        const practicePuzzlesRandom = this._gameConfig.practicePuzzles;
        this._output = JSON.stringify(puzzlesRandom, null, 2);

        const lines = [];
        lines.push(`Seed: ${Math.random.seed}`);
        lines.push(`Ruleset: ${this._gameConfig.rulesetIndex}`);
        lines.push("==================================");
        lines.push(...this.getPuzzlesOutput("Original practice puzzles", practicePuzzlesOriginal));
        lines.push("==================================");
        lines.push(...this.getPuzzlesOutput("Random practice puzzles", practicePuzzlesRandom));
        lines.push("==================================");
        lines.push(...this.getPuzzlesOutput("Original puzzles", puzzlesOriginal));
        lines.push("==================================");
        lines.push(...this.getPuzzlesOutput("Random puzzles", puzzlesRandom));

        lines.push("==================================");

        return lines.join("\n");
    }

    getPuzzlesOutput(title, puzzles) {
        const lines = [];
        lines.push(`${title}`);
        puzzles.forEach((puzzle, idx) => {
            lines.push(...this.getPuzzleOutput(puzzle, "\t"));
        });
        return lines;
    }

    getPuzzleOutput(puzzle, prefix) {
        const lines = [];
        lines.push(`${puzzle._comment.charAt(0).toUpperCase() + puzzle._comment.slice(1)}`);

        puzzle.rule.correctInput.forEach((item, index) => {
            const seqStr = puzzle.sequence[index].map(item2 => `${item2.spot}:${item2.variation.amount}${item2.variation.pattern}`).join(", ")
            lines.push(`\tAttempt ${index}: '${puzzle.rule.id[index]}', correct spots: ${item}, sequence: ${seqStr}`);
        });
        return lines.map(line => `${prefix}${line}`);
    }

}